import { render, staticRenderFns } from "./profile-change-permissions.vue?vue&type=template&id=6ab2254e&"
import script from "./profile-change-permissions.vue?vue&type=script&lang=js&"
export * from "./profile-change-permissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports